import { hasPermission } from './permissionUtils';
import type { PermissionCode } from './types';

export const VIEW_DASHBOARD = 'VIEW_DASHBOARD';
export const VIEW_SG_DASHBOARD = 'VIEW_SG_DASHBOARD';

export const NORMAL_DASHBOARD_PATH = '/dashboards';
export const SG_DASHBOARD_PATH = '/dashboards/sg';
export const OPERATIONAL_DASHBOARD_PATH = '/dashboards/operational';

export function hasSgDashboardAccess(permissions: ReadonlySet<PermissionCode>): boolean {
  return hasPermission(permissions, VIEW_SG_DASHBOARD);
}

export function hasNormalDashboardAccess(permissions: ReadonlySet<PermissionCode>): boolean {
  return hasPermission(permissions, VIEW_DASHBOARD);
}

export function hasAnyDashboardAccess(permissions: ReadonlySet<PermissionCode>): boolean {
  return hasSgDashboardAccess(permissions) || hasNormalDashboardAccess(permissions);
}

/** Preferred dashboard route when the user has dashboard access. SG takes precedence. */
export function resolveDashboardPath(permissions: ReadonlySet<PermissionCode>): string | null {
  if (hasSgDashboardAccess(permissions)) return SG_DASHBOARD_PATH;
  if (hasNormalDashboardAccess(permissions)) return OPERATIONAL_DASHBOARD_PATH;
  return null;
}
